import { useCallback } from 'react'
import type {
  CompiledKMachine,
  KExecutionState,
  TMState,
  TuringMachine,
} from '../engine/types'
import { stepK } from '../engine/ku'
import { stepTM } from '../engine/turing'
import { useDiscreteRunner } from '../../../../lib/simulation-core'

export function useKMachineRunner(
  initialState: KExecutionState,
  machine: CompiledKMachine,
) {
  const step = useCallback(
    (state: KExecutionState) => stepK(state, machine),
    [machine],
  )
  return useDiscreteRunner({
    initialState,
    step,
    isTerminal: (state) => state.outcome !== 'running',
  })
}

export function useTuringMachineRunner(
  initialState: TMState,
  machine: TuringMachine,
) {
  const step = useCallback((state: TMState) => stepTM(state, machine), [machine])
  return useDiscreteRunner({
    initialState,
    step,
    isTerminal: (state) => state.outcome !== 'running',
    intervalMs: (speed) => Math.max(70, 420 / speed),
  })
}
